import { Suspense, lazy } from 'react';
// import { Navigate } from 'react-router-dom';
import SuspenseLoader from 'src/components/SuspenseLoader';

const Loader = (Component) => (props) =>
  (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );

// MyItarra

const LocalAccess = Loader(
  lazy(() => import('src/content/myitarra/localaccess'))
);

const RemoteAccess = Loader(
  lazy(() => import('src/content/myitarra/remoteaccess'))
);

const Test = Loader(
  lazy(() => import('src/content/myitarra/test'))
);

const MyKeys = Loader(
  lazy(() => import('src/content/myitarra/mykeys'))
);

const MyMaps = Loader(
  lazy(() => import('src/content/myitarra/mymaps'))
);

const MyFleet = Loader(
  lazy(() => import('src/content/myitarra/myfleet'))
);



const Landscape = Loader(
  lazy(() => import('src/content/myitarra/mobile_landscape'))
);

const Portrate = Loader(
  lazy(() => import('src/content/myitarra/mobile_portrate'))
);

const myitarraRoutes = [
  {
    path: 'localaccess',
    element: <LocalAccess />
  },
  {
    path: 'remoteaccess',
    element: <RemoteAccess />
  },
  {
    path: 'test',
    element: <Test />
  },
  {
    path: 'landscape',
    element: <Landscape />
  },
  {
    path: 'myfleet',
    element: <MyFleet />
  },
  {
    path: 'mykeys',
    element: <MyKeys />
  },
  {
    path: 'mymaps',
    element: <MyMaps />
  },
  {
    path: 'portrate',
    element: (

        <Portrate />

    )
  }
];

export default myitarraRoutes;
